module.exports = __webpack_public_path__ + "LGFabout-4.e7a3f2e8.png";